<template>
  <div class="page-sub-agent">
    <div class="page-header">
      <h2>子代理人管理</h2>
    </div>
    <div class="page-body">
      <div class="mod-search">
        <a-form layout="inline" @submit="onSearch">
          <a-form-item label="子账号">
            <a-input size="large" v-model="search.login" placeholder="请输入子账号登录名" />
          </a-form-item>
          <a-form-item label="姓名">
            <a-input size="large" v-model="search.name" placeholder="请输入姓名" />
          </a-form-item>
          <a-form-item>
            <a-button size="large" type="primary" html-type="submit" :loading="loading">查询</a-button>
            <a-button size="large" @click="onAdd" :loading="loading">添加</a-button>
          </a-form-item>
        </a-form>
      </div>
      <a-table rowKey="id" :columns="columns" :data-source="list" :locale="{emptyText: '暂无数据'}" :pagination="{current: current, total: total}" @change="onChange">
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="userType" slot-scope="text">{{ text === 2 ? '子账号' : '-' }}</span>
        <span slot="status" slot-scope="text">{{ text === 0 ? '启动' : '禁用' }}</span>
        <span slot="createTime" slot-scope="text">{{ text | format }}</span>
        <a href="javascript: void();" slot="action" slot-scope="text, record" @click="onChangeStatus(record)">{{ record.status === 0 ? '禁用' : '启动' }}</a>
      </a-table>
    </div>
    <a-modal
      title="添加子账号"
      :visible="visible"
      :confirm-loading="confirmLoading"
      destroyOnClose
      wrapClassName="sub-agent-form"
      width="90%"
      okText="确认"
      cancelText="取消"
      @ok="onOk"
      @cancel="onCancel"
    >
      <user ref="user" @verify="onVerify"></user>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { fetchSubAgentList, addSubAgent, changeAgentStatus } from '@/api/member'
import { verify } from '@/api/verify'
import User from '@/pages/company-register/components/user'
import './index'

export default {
  data () {
    return {
      search: {
        login: '',
        name: ''
      },
      columns: [
        {
          key: 'index',
          title: '序号',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '登录用户名（登录账号）',
          dataIndex: 'login'
        },
        {
          title: '联系人姓名',
          dataIndex: 'fullName'
        },
        {
          title: '联系手机',
          dataIndex: 'phone'
        },
        {
          title: '账号类型',
          dataIndex: 'userType',
          scopedSlots: { customRender: 'userType' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '注册时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      list: [],
      current: 1,
      total: 0,
      loading: false,
      confirmLoading: false,
      visible: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      },
      wrapperColOffset: {
        span: 19, offset: 5
      },
      form: this.$form.createForm(this)
    }
  },
  created () {
    this.fetch({})
  },
  methods: {
    // 获取列表
    async fetch (params) {
      this.loading = true

      try {
        const { login, name } = this.search
        const { list, currentPage, total } = await fetchSubAgentList({
          login,
          name,
          pageSize: 10,
          ...params
        })

        this.list = list
        this.current = currentPage
        this.total = total
        this.loading = false
      } catch (err) {
        this.$error({
          content: err.message,
          centered: true
        })
        this.loading = false
      }
    },
    onSearch (e) {
      e && e.preventDefault()
      this.fetch({
        currentPage: 1
      })
    },
    onAdd () {
      this.visible = true
    },
    async onChangeStatus (record) {
      this.$confirm({
        title: '温馨提示',
        content: `确定要${record.status === 0 ? '禁用' : '启动'}子账号${record.login}？`,
        onOk: async () => {
          try {
            this.loading = true

            await changeAgentStatus({
              event: record.status === 0 ? 'DENY' : 'OPEN',
              userId: record.uid
            })

            this.$success({
              content: `${record.status === 0 ? '禁用' : '启动'}子账号${record.login}成功`,
              centered: true,
              onOk: () => {
                this.loading = false
                this.onSearch()
              }
            })
          } catch (err) {
            this.loading = false
            this.$error({
              content: err.message,
              centered: true
            })
          }
        },
        okText: '确定',
        cancelText: '取消'
      })
    },
    onOk () {
      this.$refs.user.form.validateFields(async (errors, userValues) => {
        if (!errors) {
          const { token, finalToken, code, phone, email } = this.$refs.user

          if (!phone && !email) {
            this.$error({
              content: '请输入联系方式！',
              centered: true
            })
            return
          }

          if (!code) {
            this.$error({
              content: '请输入手机动态码！',
              centered: true
            })
            return
          }

          if (!token) {
            this.$error({
              content: '请拖动滑块完成验证！',
              centered: true
            })
            return
          }

          if (!finalToken) {
            this.$error({
              content: '请点击获取动态码！',
              centered: true
            })
            return
          }

          const { registerAgentUserInfo } = userValues

          if (!phone) {
            delete registerAgentUserInfo.phone
          }

          if (!email) {
            delete registerAgentUserInfo.email
          }

          delete registerAgentUserInfo.confirmPassword

          try {
            this.confirmLoading = true

            await addSubAgent({
              smsCode: code,
              token: finalToken,
              ...registerAgentUserInfo
            })

            this.confirmLoading = false
            this.visible = false
            this.$success({
              content: '添加子账号成功',
              centered: true,
              onOk: () => {
                this.onSearch()
              }
            })
          } catch (err) {
            this.confirmLoading = false
            this.$error({
              content: err.message,
              centered: true
            })
            this.$refs.user.$refs.verify.refresh()
            if (err.code.toString().includes(1000)) {
              this.$refs.user.errCode = err.code
            }
          }
        }
      })
    },
    onCancel () {
      this.visible = false
    },
    async onVerify (value, type, cb) {
      try {
        await verify({
          type,
          value
        })

        cb()
      } catch (err) {
        cb(err.message)
      }
    },
    onChange (pagination) {
      this.fetch({
        current: pagination.current
      })
    }
  },
  filters: {
    format (value) {
      if (!value) {
        return '-'
      }

      const time = moment(value)

      return time.isValid() ? time.format('YYYY-MM-DD') : '-'
    }
  },
  components: {
    User
  }
}
</script>
